import { doc, collection, getDocFromServer, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { getUser } from "./sessao";
import { fbCollectionPath } from "../hooks/useFirebase";
import { calcularCupomVenda, descontarPedido, arredondarMoeda } from "./cupomVenda";
import { calcPagamento } from "./pagamento";

export async function buscarCupomVenda(codigo, subtotal) {
  const uid=getUser()?.uid;
  const normalizado=String(codigo || "").trim().toUpperCase();
  if(!uid) throw new Error("Entre novamente na sua conta.");
  if(!/^[A-Z0-9_-]{3,40}$/.test(normalizado)) throw new Error("Informe um código de cupom válido.");
  const snap=await getDocFromServer(doc(db,"users",uid,"cupons_loja",normalizado));
  if(!snap.exists()) throw new Error("Cupom não encontrado nesta loja.");
  const cupom={...snap.data(),codigo:normalizado};
  calcularCupomVenda(cupom,subtotal);
  return cupom;
}

// Desconto, pagamento e entrada no caixa são gravados juntos. Se outro
// recebimento alterar o pedido, o operador precisa conferir o saldo novamente.
export async function registrarRecebimentoComCupom(pedido, cupom, valorReceber, metodo) {
  const user=getUser();
  if(!user?.uid) throw new Error("Entre novamente na sua conta.");
  const pedidoRef=doc(db,fbCollectionPath("pedidos"),pedido.id);
  const cupomRef=doc(db,"users",user.uid,"cupons_loja",cupom.codigo);
  const caixaRef=doc(collection(db,fbCollectionPath("caixa")));
  await runTransaction(db,async tx=>{
    const [pedidoSnap,cupomSnap]=await Promise.all([tx.get(pedidoRef),tx.get(cupomRef)]);
    if(!pedidoSnap.exists() || !cupomSnap.exists()) throw new Error("Pedido ou cupom não está mais disponível.");
    const atual={...pedidoSnap.data(),id:pedido.id};
    if(JSON.stringify(atual.pagamentos || []) !== JSON.stringify(pedido.pagamentos || []) || Number(atual.valor) !== Number(pedido.valor) || atual.sinal_pago !== pedido.sinal_pago) throw new Error("O pedido mudou. Feche e abra o recebimento para conferir o saldo.");
    const novo=descontarPedido(atual,{...cupomSnap.data(),codigo:cupom.codigo});
    const preview=descontarPedido(pedido,cupom);
    if(novo.valor !== preview.valor) throw new Error("O cupom mudou. Remova e aplique novamente antes de receber.");
    const saldo=calcPagamento(novo).saldo, valor=arredondarMoeda(valorReceber);
    if(!Number.isFinite(valor) || valor < 0 || valor > saldo + 0.005 || (valor === 0 && saldo > 0)) throw new Error("Informe um valor entre zero e o saldo do pedido.");
    const em=new Date().toISOString(), por=user.nome || "—";
    const descontoHist={tipo:"desconto",cupom:novo.cupom.codigo,valor:novo.desconto,subtotal:novo.subtotal,total:novo.valor,em,por};
    const historico=[...(atual.historico || []),descontoHist];
    const pagamentos=[...novo.pagamentos];
    if(valor > 0) {
      pagamentos.push({id:caixaRef.id,valor,metodo,em,por,cupom:novo.cupom.codigo});
      historico.push({tipo:"pagamento",valor,metodo,em,por,cupom:novo.cupom.codigo});
      tx.set(caixaRef,{descricao:`Pagamento: ${atual.produto || atual.cliente || "pedido"} · cupom ${novo.cupom.codigo}`,valor,tipo:"Entrada",origem:"pedido",pedido_id:pedido.id,cupom:novo.cupom,desconto:novo.desconto,created_at:serverTimestamp()});
    }
    tx.update(pedidoRef,{valor:novo.valor,subtotal:novo.subtotal,desconto:novo.desconto,cupom:novo.cupom,pagamentos,historico});
    if(atual.pedidoOnlineId && atual.vendedorOnlineId) tx.update(doc(db,"users",atual.vendedorOnlineId,"pedidos_online",atual.pedidoOnlineId),{total:novo.valor,subtotal:novo.subtotal,desconto:novo.desconto,cupom:novo.cupom,updated_at:Date.now()});
  });
}
